module.exports = __webpack_public_path__ + "img/msg.6dd22cfd.png";